<script setup lang="ts">
/**
 * [[Signers]] 자리 — 다른 프리셋과 같은 SignersField(추가·삭제·직책별 선택·편집).
 *   기본값 = 기존 생성 로직(*Signers 빌더)이 정하는 서명자. 사용자가 고치면 ctx.docSigners[`${docKind}_Signers`] 에 저장되고
 *   생성 시 그 문서의 서명자로 그대로 쓰인다(패널 handleCreateTask).
 */
import { computed } from 'vue';
import SignersField from '@/features/startTask/preset_task/my/preset/components/resignation/signers/SignersField.vue';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';
import { useAgmStudio } from './agmStudioContext';

const props = defineProps<{ docKind: string; caption?: string; note?: string }>();
const ctx = useAgmStudio();
const key = computed(() => `${props.docKind}_Signers`);

const auto = computed<SignerEntry[]>(() => ctx.signerList(props.docKind).map((s, i) => ({
  id: `agm-${props.docKind}-${i}`,
  name: s.name,
  title: props.caption || '',
  role: s.role || 'signer',
  email: s.email || undefined,
  contactCd: s.contactCd || undefined,
  isManual: true,
  showTitle: !!props.caption,
  _signerLayout: 'box',
} as SignerEntry)));

const value = computed<SignerEntry[]>(() => (key.value in ctx.docSigners ? ctx.docSigners[key.value] : auto.value));
function onUpdate(list: SignerEntry[]) { ctx.docSigners[key.value] = Array.isArray(list) ? list : []; }
</script>

<template>
  <SignersField
    :model-value="value"
    :board-label="caption || ''"
    :var-key="key"
    :entity-cd="ctx.entityCd.value"
    @update:model-value="onUpdate"
  />
</template>
